import type { Messages } from '../i18n/messages';

export const settingsMessages: Messages = {
  'settings.profile.title': { en: 'Profile', fun: 'Who Dis' },
  'settings.profile.signedInUser': {
    en: 'Signed-in user',
    fun: 'The legend themselves',
  },
  'settings.appearance.title': { en: 'Appearance', fun: 'Drip Settings' },
  'settings.appearance.theme': { en: 'Theme', fun: 'Vibe' },
  'settings.appearance.theme.system': {
    en: 'System',
    fun: 'Whatever the OS says',
  },
  'settings.appearance.palette': { en: 'Palette', fun: 'Color mood' },
  'settings.appearance.funMode': { en: 'Fun mode', fun: 'Fun mode' },
  'settings.identity.title': { en: 'Identity', fun: 'Your Alter Ego' },
  'settings.identity.userEntity': {
    en: 'User entity',
    fun: 'Your player card',
  },
  'settings.identity.ownership': { en: 'Ownership', fun: 'Your turf' },
  'settings.general.page.title': { en: 'General', fun: 'Basics' },
  'settings.authProviders.page.title': {
    en: 'Authentication Providers',
    fun: 'Login Wizardry',
  },
  'settings.authProviders.title': {
    en: 'Authentication providers',
    fun: 'Login wizardry',
  },
  'settings.authProviders.description': {
    en: 'Connect the identity providers used to sign in and to authorize API access.',
    fun: 'Hook up the magic keys that let you in and let the app talk to your stuff.',
  },
  'settings.authProviders.empty.title': {
    en: 'No providers configured',
    fun: 'Nothing plugged in yet',
  },
  'settings.authProviders.empty.description': {
    en: 'No authentication providers are set up for this Backstage instance.',
    fun: "This Backstage hasn't hooked up any login providers yet.",
  },
  'settings.authProviders.signIn': { en: 'Sign in', fun: 'Hop in' },
  'settings.authProviders.signOut': { en: 'Sign out', fun: 'Peace out' },
};
